import { useLocation, useRoutes } from "react-router-dom";
import { LoanRoutes } from "./routes";
import AppContainer from "components/Layout/AppContainer";

export default function Pages() {
  const location = useLocation();
  const routes = useRoutes(LoanRoutes);

  const noContainerRoutes = ["/drugstoc", "/buildafrica"];

  const shouldWrap = !noContainerRoutes.includes(location.pathname);
  return shouldWrap ? <AppContainer>{routes}</AppContainer> : routes;
}
